import CancelIcon from '@/components/customercenter-ui/icons/cancel';
import { SITE_KEY_MAP_OC } from '@/constants/constant';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { getSelectedDivision } from '@/helpers/utils/siteUtils';
const OrderCancelMessage = ({ order }: any) => {
  return (
    <section className="w-full md:max-w-[1141px]">
      <p className="pt-8 text-2xl font-bold text-black">
        {mapLocaleToMeaningfulFormat().orderSuspendedTitle} &nbsp;
        {mapLocaleToMeaningfulFormat().orderHash}
        {order?.orderNumber}
      </p>
    </section>
  );
};

const OrderCancelBox = () => {
  const selectedDivision = getSelectedDivision();
  const siteName = (selectedDivision && SITE_KEY_MAP_OC?.[selectedDivision]) ?? 'Stoneberry';
  return (
    <section className="rounded-sm border-2 border-[#DF2429] bg-[#FFE1E280] p-5 shadow-md lg:mx-0">
      <section className="flex items-center pb-3 ">
        <section className=" pr-3">
          <CancelIcon className="h-6 w-7" />
        </section>
        <p className="text-xl font-bold leading-7 text-[#DF2429]">{mapLocaleToMeaningfulFormat().orderSuspended}</p>
      </section>
      <section className=" text-base font-normal leading-6 ">
        {mapLocaleToMeaningfulFormat([siteName]).orderSuspendedMessage}
      </section>
    </section>
  );
};

export { OrderCancelMessage, OrderCancelBox };
